import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useMatch } from 'react-router-dom';
import Navbar from './components/Navbar';
import Pos from './pages/POS';
import Menu from './pages/Menu';
import { API_BASE_URL, apiService } from './services/apiServices';

function GlobalInstallHeader() {
  const menuMatch = useMatch('/menu/:shopCode');
  const posMatch = useMatch('/pos/:shopCode');
  const shopCode = menuMatch?.params?.shopCode || posMatch?.params?.shopCode;
 
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  
  // Track installation status per shopCode
  const [isInstalled, setIsInstalled] = useState(false);

  const [shopInfo, setShopInfo] = useState({
    name: 'Sidra Pizza & Sweets',
    logo: '/logo.png'
  });

  // 1. Sync installation state whenever shopCode changes
  useEffect(() => {
    if (!shopCode) return;

    const storageKey = `pwa_installed_${shopCode}`;
    const checkStandalone = () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone ||
        document.referrer.includes('android-app://');

      if (isStandalone || localStorage.getItem(storageKey) === 'true') {
        setIsInstalled(true);
      } else {
        setIsInstalled(false);
      }
    };

    checkStandalone();

    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handleDisplayChange = (e) => {
      if (e.matches) {
        setIsInstalled(true);
        localStorage.setItem(storageKey, 'true');
      }
    };

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleDisplayChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleDisplayChange);
      }
    };
  }, [shopCode]);

  // 2. Listen for install events specific to current context
  useEffect(() => {
    const fetchShop = async() => {
 const data = await  apiService.get(`/getlink-apikey/shop-data-json/${shopCode}`);
      console.log('data:',data)
      const parsedData = JSON.parse(data.report[0].full_shop_data);
             console.log('data:',parsedData)
              // if (!resBiz.ok || !resMenu.ok) throw new Error('Shop not found');
       const businessModule = parsedData.business;
      const business = businessModule.default || businessModule;
console.log('business:',business)
      const shopName = business.name || 'Sidra Pizza & Sweets';
      const shopLogo = `${API_BASE_URL}/${business.logo}` || `/data/shops/${shopCode}/logo.png`;

      setShopInfo({ name: shopName, logo: shopLogo });
      document.title = shopName;
    }

    fetchShop();
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    const handleAppInstalled = () => {
      setIsInstalled(true);
      if (shopCode) {
        localStorage.setItem(`pwa_installed_${shopCode}`, 'true');
      }
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
    
  }, [shopCode]);

  // 3. Dynamically generate Shop Manifest with UNIQUE scope & id
 useEffect(() => {
  async function updateShopManifestAndInfo() {
    if (!shopCode) return;

    try {
      // const businessModule = await import(`./data/shops/${shopCode}/business.json`);

      const data = await  apiService.get(`/getlink-apikey/shop-data-json/${shopCode}`);
      console.log('data:',data)
      const parsedData = JSON.parse(data.report[0].full_shop_data);
             console.log('data:',parsedData)
              // if (!resBiz.ok || !resMenu.ok) throw new Error('Shop not found');
       const businessModule = parsedData.business;
      const business = businessModule.default || businessModule;
console.log('business:',business)
      const shopName = business.name || 'Sidra Pizza & Sweets';
      const shopLogo = `${API_BASE_URL}/${business.logo}` || `/data/shops/${shopCode}/logo.png`;

      setShopInfo({ name: shopName, logo: shopLogo });
      document.title = shopName;

      // Make sure paths are resolved relative to origin
      const startUrlPath = `/menu/${shopCode}`;
      const absoluteStartUrl = new URL(startUrlPath, window.location.origin).href;
      const absoluteScopeUrl = new URL(startUrlPath, window.location.origin).href;
      const absoluteLogoUrl = new URL(shopLogo, window.location.origin).href;

      const dynamicManifest = {
        id: startUrlPath,
        scope: absoluteScopeUrl, // Fix 1: Valid absolute scope URL
        start_url: absoluteStartUrl,
        short_name: shopName,
        name: shopName,
        display: 'standalone',
        background_color: '#ffffff',
        theme_color: '#10B981',
        orientation: 'portrait',
        icons: [
          // Fix 2 & 3: Match actual image dimensions & separate icon purposes
          {
            src: absoluteLogoUrl,
            sizes: '512x512',
            type: 'image/png',
            purpose: 'any'
          },
          {
            src: absoluteLogoUrl,
            sizes: '512x512',
            type: 'image/png',
            purpose: 'maskable'
          }
        ]
      };

      const stringManifest = JSON.stringify(dynamicManifest);
      const blob = new Blob([stringManifest], { type: 'application/manifest+json' });
      const manifestURL = URL.createObjectURL(blob);

      let manifestLink = document.querySelector('link[rel="manifest"]');
      if (manifestLink) {
        if (manifestLink.href.startsWith('blob:')) {
          URL.revokeObjectURL(manifestLink.href); // Clean up memory
        }
      } else {
        manifestLink = document.createElement('link');
        manifestLink.rel = 'manifest';
        document.head.appendChild(manifestLink);
      }
      manifestLink.href = manifestURL;

    } catch (error) {
      console.error('Could not load dynamic shop manifest:', error.message);
    }
  }

  updateShopManifestAndInfo();
}, [shopCode]);
  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setIsInstalled(true);
        if (shopCode) {
          localStorage.setItem(`pwa_installed_${shopCode}`, 'true');
        }
        alert(`Thank you for installing ${shopInfo.name}! 🍕🍰`);
      }
      setDeferredPrompt(null);
    } else {
      alert(`To install ${shopInfo.name}:\n\nTap your browser menu (⋮ or Share) and select "Add to Home Screen".`);
    }
  };

  return (
    <>
           {!isInstalled && (
    <header style={headerStyle}>
   
      <div style={brandStyle}>
        <img 
          src={shopInfo.logo} 
          alt={`${shopInfo.name} Logo`} 
          style={logoStyle} 
          onError={(e) => { e.target.style.display = 'none'; }} 
        />
        <h2 style={{ margin: 0, fontSize: '1.25rem', color: '#111827' }}>
          {shopInfo.name}
        </h2>
      </div>
          

      {!isInstalled && (
        <button onClick={handleInstallClick} style={buttonStyle}>
          📲 Install
        </button>
      )}
    </header>
           )}
    </>
  );
}

function MainLayout() {
  const location = useLocation();
  const isMenuPath = useMatch('/menu/:shopCode');
 const isMenuPath2 = useMatch('/menu/:shopCode/:design');

  const hideNavbar = location.pathname === '/' || Boolean(isMenuPath)  || Boolean(isMenuPath2);

  return (
    <>
      <GlobalInstallHeader />
      {!hideNavbar && <Navbar />}

      <div style={{ padding: '1.5rem', maxWidth: '1200px', margin: '0 auto' }}>
        <Routes>
          <Route path="/menu/:shopCode" element={<Menu />} />
            <Route path="/menu/:shopCode/:design" element={<Menu />} />
          
          <Route path="/pos/:shopCode" element={<Pos />} />
        </Routes>
      </div>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <MainLayout />
    </Router>
  );
}

// Inline Styles
const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0.75rem 1.5rem',
  backgroundColor: '#ffffff',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  borderBottom: '1px solid #f3f4f6'
};

const brandStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem'
};

const logoStyle = {
  width: '36px',
  height: '36px',
  objectFit: 'contain'
};

const buttonStyle = {
  backgroundColor: '#f3f4f6',
  border: '1px solid #d1d5db',
  borderRadius: '20px',
  padding: '0.4rem 1rem',
  fontWeight: '600',
  cursor: 'pointer',
  fontSize: '0.875rem'
};